/**
 * @generated SignedSource<<dfab35a67434e51f7e691672cbdf532c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraSidebarMenuDisplayMode = "MOST_RECENT_ONLY" | "STARRED" | "STARRED_AND_RECENT" | "%future added value";
export type JiraWorkManagementUserLicenseSeatEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type Nav4ProjectsContent$data = {
  readonly jira: {
    readonly canCreateProject: boolean | null;
    readonly jwmLicensing: {
      readonly currentUserSeatEdition: JiraWorkManagementUserLicenseSeatEdition | null;
    } | null;
  };
  readonly jira_projectsSidebarMenu: {
    readonly displayMode: JiraSidebarMenuDisplayMode | null;
    readonly favouriteLimit: number | null;
    readonly favourites: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly projectKey: string;
          readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectMenuItem">;
        };
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    };
    readonly mostRecent: {
      readonly id: string;
      readonly projectKey: string;
      readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectMenuItem">;
    } | null;
    readonly mostRecentFromHistory: {
      readonly id: string;
      readonly isFavourite: boolean | null;
      readonly projectKey: string;
      readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectMenuItem">;
    } | null;
    readonly recentLimit: number | null;
    readonly recents: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly projectKey: string;
          readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectMenuItem">;
        };
      } | null> | null;
    };
  };
  readonly " $fragmentType": "Nav4ProjectsContent";
};
export type Nav4ProjectsContent$key = {
  readonly " $data"?: Nav4ProjectsContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectsContent">;
};

import Nav4ProjectsContentQuery_graphql from './Nav4ProjectsContentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "RequiredField",
  "field": {
    "kind": "ScalarField",
    "name": "id"
  },
  "action": "THROW"
},
v2 = {
  "kind": "RequiredField",
  "field": {
    "alias": "projectKey",
    "kind": "ScalarField",
    "name": "key"
  },
  "action": "THROW"
},
v3 = {
  "kind": "FragmentSpread",
  "name": "Nav4ProjectMenuItem"
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "concreteType": "JiraProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v4/*: any*/)
      },
      "action": "THROW"
    }
  ]
},
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURL"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": Nav4ProjectsContentQuery_graphql
    }
  },
  "name": "Nav4ProjectsContent",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canCreateProject",
            "args": [
              (v0/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "CREATE_PROJECT"
              }
            ],
            "kind": "ScalarField",
            "name": "canPerform"
          },
          {
            "args": [
              (v0/*: any*/)
            ],
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "currentUserSeatEdition"
              }
            ]
          }
        ]
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          (v0/*: any*/),
          {
            "kind": "Variable",
            "name": "currentURL",
            "variableName": "currentURL"
          }
        ],
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "mostRecent",
            "plural": false,
            "selections": (v4/*: any*/)
          },
          {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "mostRecentFromHistory",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              },
              (v3/*: any*/)
            ]
          },
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 15
                }
              ],
              "concreteType": "JiraProjectConnection",
              "kind": "LinkedField",
              "name": "favourites",
              "plural": false,
              "selections": [
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "hasNextPage"
                    }
                  ]
                },
                (v5/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": "favourites(first:15)"
            },
            "action": "THROW"
          },
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                }
              ],
              "concreteType": "JiraProjectConnection",
              "kind": "LinkedField",
              "name": "recents",
              "plural": false,
              "selections": [
                (v5/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": "recents(first:20)"
            },
            "action": "THROW"
          },
          {
            "kind": "ScalarField",
            "name": "favouriteLimit"
          },
          {
            "kind": "ScalarField",
            "name": "recentLimit"
          },
          {
            "kind": "ScalarField",
            "name": "displayMode"
          }
        ]
      },
      "action": "THROW"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "a836bf506bd69077713668e8d8cbc27c";

export default node;
